<template>
    <section>
        <Header></Header>
        <div class="body">
            <SectionReferenceWelcome/>
            <SectionReference label="레퍼런스"/>
        </div>
        <Footer></Footer>
    </section>
</template>

<script>
    import Header from '../components/Header.vue'
    import Footer from '../components/Footer.vue'
    import SectionReferenceWelcome from '../components/SectionReferenceWelcome.vue'
    import SectionReference from '../components/SectionReference.vue'
    import loginService from '../services/loginService'
    import client from "../client/client"

    export default {
        name: "Main",
        components: {
            Header,
            Footer,
            SectionReferenceWelcome,
            SectionReference,
        },
        data: function () {
            return {
                success: false,
                loginErrorMsg: "",
                username: "",
                password: "",
            }
        },
        mounted() {
            
        },
        methods: {
            async login() {
                if(!this.username || !this.password)
                    return;

                const result = await loginService.login(this.username, this.password);
                if (result.r) {
                    this.success = true;
                    this.loginErrorMsg = '';
                } else {
                    this.success = false;
                    this.loginErrorMsg = result.msg;
                }
                console.log(result)

            }
        }
    }
</script>

<style scoped>

</style>
